import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { SignIn } from "../components/login/signin";
import { OtpRoute } from "../components/login/otp/OtpRoute";
import { Dashboard } from "../components/dashboard";
import { TermsScreen } from "../components/onboarding";
import { TryNow } from "../components/try-now";
import { useAuthState, hasPendingTryNowJourney } from "../hallticket-lib";

function getPostAuthRedirect(state: unknown): string | null {
  if (typeof state !== "object" || state === null || !("postAuthRedirect" in state)) {
    return null;
  }

  const redirect = (state as { postAuthRedirect?: unknown }).postAuthRedirect;
  return redirect === "/dashboard/results" ? redirect : null;
}

function getOnboardingState(state: unknown): { mobile?: string; postAuthRedirect?: string } | undefined {
  if (typeof state !== "object" || state === null) {
    return undefined;
  }

  const typed = state as { mobile?: unknown; postAuthRedirect?: unknown };
  const mobile = typeof typed.mobile === "string" ? typed.mobile : undefined;
  const postAuthRedirect = typed.postAuthRedirect === "/dashboard/results" ? typed.postAuthRedirect : undefined;

  return mobile || postAuthRedirect ? { mobile, postAuthRedirect } : undefined;
}

export function AppRoutes() {
  const authState = useAuthState();
  const location = useLocation();

  const isSignedIn = authState.status === "signed_in";
  const isSignedOut = authState.status === "signed_out";
  const needsOnboarding = authState.status === "needs_onboarding";
  const postAuthRedirect = getPostAuthRedirect(location.state);
  const onboardingState = getOnboardingState(location.state);
  const signedInRedirect = postAuthRedirect ?? (hasPendingTryNowJourney() ? "/dashboard/results" : "/dashboard");

  const authRouteRedirect = isSignedIn
    ? signedInRedirect
    : needsOnboarding
      ? "/terms"
      : null;

  const onboardingRedirect = isSignedIn
    ? signedInRedirect
    : "/try";

  const dashboardRedirect = isSignedOut ? "/try" : "/terms";

  return (
    <Routes>
      <Route
        path="/"
        element={
          isSignedIn ? <Navigate to={authRouteRedirect!} replace /> : needsOnboarding ? <Navigate to="/terms" replace /> : <TryNow />
        }
      />
      <Route
        path="/try"
        element={isSignedIn ? <Navigate to={authRouteRedirect!} replace /> : needsOnboarding ? <Navigate to="/terms" replace /> : <TryNow />}
      />

      <Route path="/signin" element={authRouteRedirect ? <Navigate to={authRouteRedirect} replace state={onboardingState} /> : <SignIn />} />
      <Route path="/otp" element={authRouteRedirect ? <Navigate to={authRouteRedirect} replace state={onboardingState} /> : <OtpRoute />} />

      <Route path="/terms" element={needsOnboarding ? <TermsScreen /> : <Navigate to={onboardingRedirect} replace />} />

      <Route path="/dashboard" element={isSignedIn ? <Dashboard /> : <Navigate to={dashboardRedirect} replace />} />
      <Route path="/dashboard/results" element={isSignedIn ? <Dashboard /> : <Navigate to={dashboardRedirect} replace />} />
      <Route path="/dashboard/colleges" element={isSignedIn ? <Dashboard /> : <Navigate to={dashboardRedirect} replace />} />
      <Route path="/dashboard/spot-round" element={isSignedIn ? <Dashboard /> : <Navigate to={dashboardRedirect} replace />} />
      <Route path="/dashboard/profile" element={isSignedIn ? <Dashboard /> : <Navigate to={dashboardRedirect} replace />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
